import { ConfigRenderService } from "@/services/config-render/config-render-service";
import { InjectionKey } from "vue";

export const CONFIG_RENDER_SERVICE_INJECTION_KEY: InjectionKey<ConfigRenderService> =
  Symbol("config-render-service");
